import { getApiErrorMessage } from '@components/common/util/util';
import { apiAuthCaller } from '@services/apiCaller';
import { IRootStore } from '@stores/index';
import {
  ITrackingPlan,
  ITrackingPlanStore,
  TrackingPlanStore,
} from '@stores/trackingPlans/trackingPlan';
import { CatchErr } from '@utils/types';
import { action, observable } from 'mobx';

export interface ITrackingPlanListStore {
  plans: ITrackingPlanStore[];
  firstLoad: boolean;
  getPlans(): Promise<void>;
  getById(id: string): ITrackingPlanStore | undefined;
  unlinkTrackingPlan(
    trackingPlanId: string,
    sourceId: string,
    onSuccess?: () => void,
  ): Promise<void>;
}

export class TrackingPlansListStore implements ITrackingPlanListStore {
  @observable plans: ITrackingPlanStore[] = [];

  @observable rootStore: IRootStore;

  @observable firstLoad = false;

  constructor(root: IRootStore) {
    this.rootStore = root;
  }

  @action.bound
  async getPlans() {
    const {
      userStore: { token },
    } = this.rootStore;
    try {
      const response = await apiAuthCaller(token).get('/trackingPlans');
      this.plans = response.data.map(
        (plan: ITrackingPlan) => new TrackingPlanStore(plan, this.rootStore),
      );
    } catch {}
    this.firstLoad = true;
  }

  getById(id: string) {
    return this.plans.find((plan) => plan.id === id);
  }

  async unlinkTrackingPlan(trackingPlanId: string, sourceId: string, onSuccess?: () => void) {
    const {
      userStore: { token },
      messagesStore,
      sourcesListStore,
    } = this.rootStore;
    try {
      await apiAuthCaller(token).delete(`/trackingPlans/${trackingPlanId}/sources/${sourceId}`);
      sourcesListStore.updateSourceInList({
        ...sourcesListStore.sourceById(sourceId)!,
        trackingPlanConfig: undefined,
      });
      onSuccess?.();
    } catch (err: CatchErr) {
      messagesStore.showErrorMessage(
        getApiErrorMessage(err, 'Failed to unlink source from tracking plan'),
      );
    }
  }
}
